import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/layer/category/layer/add/layer.category.layer.add.mutation.gql"
import type {
  LayerCategoryLayerAddMutation,
  LayerCategoryLayerAddMutationVariables,
} from "@/v2-backoffice-client/layer/category/layer/add/__types__/layer.category.layer.add.mutation"

type Options = MutationHookOptions<
  LayerCategoryLayerAddMutation,
  LayerCategoryLayerAddMutationVariables
>

export function useLayerCategoryLayerAddMutation(options?: Options) {
  return useMutation<
    LayerCategoryLayerAddMutation,
    LayerCategoryLayerAddMutationVariables
  >(mutation, options)
}
